module.exports = __webpack_public_path__ + "img/gold_logo.6ea8707b.svg";